module.exports = __webpack_public_path__ + "img/20210420_120041.53f69ac7.jpg";